import styled from '@emotion/styled';
import { Tooltip } from '~/shared/components';
import { StyledToolTipContent } from '~/shared/components/Tooltip/styled';

export const StyledOpeningHoursTable = styled.table(({ theme }) => ({
    caption: {
        textAlign: 'left',
        marginBottom: theme.spaces[2],
    },
    'td:first-of-type': {
        paddingRight: '1ch',
    },
}));

export const StyledOpeningHourTooltip = styled(Tooltip)({
    [`${StyledToolTipContent}`]: {
        whiteSpace: 'nowrap',
    },
});
